import { Eye, EyeOff } from '@untitledui/icons'

export default function Input({
    type = 'text',
    inputMode,
    placeholder,
    value,
    onChange,
    disabled,
    error,
    showPasswordToggle,
    isPasswordVisible,
    onTogglePasswordVisibility,
}) {
    return (
        <div className="flex flex-col gap-[8px]">
            <div className="relative">
                <input
                    type={type}
                    inputMode={inputMode}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    className={`
                        w-full p-3 rounded-lg
                        bg-[#F3F4F6] border
                        text-base text-[#000D1E] placeholder-[#000D1E]/40
                        outline-none transition-[border-color] duration-200
                        h-[45px]
                        disabled:cursor-not-allowed
                        ${showPasswordToggle ? 'pr-12' : ''}
                        ${error ? 'border-[#E84341]' : 'border-transparent focus:border-[#3F81F7]'}
                    `}
                />
                {showPasswordToggle && (
                    <button
                        type="button"
                        onClick={onTogglePasswordVisibility}
                        className="absolute right-0 top-0 h-full px-4 flex items-center text-[#000D1E]/40 hover:text-[#000D1E]/60 transition-colors cursor-pointer"
                    >
                        {isPasswordVisible ? (
                            <EyeOff size={20} />
                        ) : (
                            <Eye size={20} />
                        )}
                    </button>
                )}
            </div>

            {error && (
                <span className="text-[12px] text-[#E84341]">{error}</span>
            )}
        </div>
    )
}
